import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { Component, ElementRef, EventEmitter, Inject, OnInit, Output, PLATFORM_ID, Renderer2, ViewChild, ChangeDetectorRef, AfterViewInit, HostListener } from '@angular/core';

declare var bootstrap: any;
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { URLS } from '../../_config/api.config';
import { ApiService } from '../../services/api-data.service';
import { CommonService } from '../../services/common.service';
import { SideNavComponent } from '../sideNav/sideNav.component';
import { ModalService } from '../../services/modal.service';


declare var bootstrap: any;

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, AfterViewInit {
	@Output() verifiedMailStatus = new EventEmitter<string>();
	@ViewChild('child') private child: SideNavComponent;
	@ViewChild('cancelHeaderLogoutModal') cancelHeaderLogoutModal;
	@ViewChild('menuModalClose') menuModalClose;
	@ViewChild('openSurveyModal') openSurveyModal;
	@ViewChild('openTermsModal') openTermsModal;
	@ViewChild('openMenuModal') openMenuModal;
	private subscription: Subscription = new Subscription();
	public isLogin: boolean = false;
	public userName = '';
	notificationCount: any = 0;
	notificatonMessages: any[] = [];
	homeActive = false;
	isLoggingOut = false;
	isModalActive = false;
	isAssociatedPartner: any;
	public isLoading: boolean = false;
	isAboutUsActive = false;
	
	// Terms modal properties
	showTermsModal = false;
	termsContent: any = null;
	currentSection: number = 1;
	totalSections: number = 1;
	isAtBottom: any = false;
	agreed = false;
	orgId: string;
	pageUrl: any;
	myOrgClicked = true;
	myOrgClicked2=true;
	myProfileClicked = true;
	myProfileClicked2=true;
	hideAuthBtn=false;
	isUserMenuOpen = false;

	constructor(
		private router: Router,
		private commonService: CommonService,
		private dataService: ApiService,
		private toastr: ToastrService,
		private authService: AuthenticationService,
		@Inject(DOCUMENT) private document: any,
		@Inject(PLATFORM_ID) private platformId: Object,
		private renderer: Renderer2,
		private el: ElementRef,
		private modalService: ModalService,
		private sanitizer: DomSanitizer,
		private cdr: ChangeDetectorRef,
	) {
		const currentPath = this.router.url;
		if (currentPath.includes('/about-us')) {
			this.isAboutUsActive = true;
		} else {
			this.isAboutUsActive = false;
		}
		this.commonService.eventObservable.subscribe(data => {
			if (data.event == 'profileDataChange') {
				this.userName = this.commonService.localStorageGet('firstName') + ' ' + this.commonService.localStorageGet('lastName');
			}
		})
	}
	activeClass = ''

	ngOnInit() {
		let isLogin = this.authService.hasToken();

		if (isLogin) {
			this.isLogin = true;
		} else {
			this.isLogin = false;
		}

		if (isPlatformBrowser(this.platformId)) {
			const fullPath = window.location.pathname;
			const orgPathIndex = fullPath.indexOf('/org/');
			if (orgPathIndex !== -1) {
				this.pageUrl = fullPath.substring(orgPathIndex + 5);
			}
			const currentUrl = this.router.url; 
			if (!this.isLogin && currentUrl.includes('/org')) {
				this.getOrgId();
			}
		}

		this.authService.isLoggedIn().subscribe((state) => {
			this.isLogin = state;
		});

		const token = this.commonService.localStorageGet('accessToken');
		if (token) {
			this.getNotiCount();
			this.getNotificationList();
		}

		let firstName = this.commonService.localStorageGet('firstName');
		let lastName = this.commonService.localStorageGet('lastName');
		// this.userName = firstName + ' ' + lastName;
		this.userName = (firstName || '') + ' ' + (lastName || '');
		this.commonService.profileName.subscribe((res) => {
			this.userName = res;
		});
		this.commonService.updatedNotificationCount.subscribe((res) => {
			this.notificationCount = res;
		});

		// Subscribe to terms modal events
		this.modalService.termsModal$.subscribe((show: boolean) => {
			// Only show modal on allowed routes
			const currentUrl = this.router.url;
			const isAllowedRoute = currentUrl === '/charities' || currentUrl === '/dashboard' || currentUrl.startsWith('/newOrgDashboard') || currentUrl.startsWith('/neworgdashboard');
			
			if (show && isAllowedRoute) {
				this.showTermsModal = show;
				this.cdr.detectChanges();
				if (this.openTermsModal && isPlatformBrowser(this.platformId)) {
					setTimeout(() => {
						this.openTermsModal.nativeElement.click();
					}, 100);
				}
			} else if (!show) {
				// Always allow hiding the modal
				this.showTermsModal = show;
				this.cdr.detectChanges();
			}
		});

		this.modalService.termsContent$.subscribe((content: any) => {
			if (content) {
				this.termsContent = this.sanitizer.bypassSecurityTrustHtml(content);
			}
		});

        
		if(this.router.url=='/login' || this.router.url=='/create-account'){
          this.hideAuthBtn=true;
		}
		if (isPlatformBrowser(this.platformId)) {
			if (this.router.url === '/nonProfit') {

				var elems = this.document.getElementsByClassName('nonprofits')[0];
				if (elems != null) {
					elems.classList.remove("active");
					elems.className = "active";
				}

			}
			if (this.router.url === '/resources') {

				var elems = this.document.getElementsByClassName('resources')[0];
				if (elems != null) {
					elems.classList.remove("active");
					elems.className = "active";
				}

			}

			if (this.router.url === '/about-us') {

				var elems = this.document.getElementsByClassName('aboutUs')[0];
				if (elems != null) {
					elems.classList.remove("active");
					elems.className = "active aboutUs aboutLink";
				}
			}

			// Release5 Article menu revert
			if (this.router.url === '/articles') {
				var elems = this.document.getElementsByClassName('articles')[0];
				if (elems != null) {
					elems.classList.remove("active");
					elems.className = "active";
				}
			}
		if (this.router.url === '/dashboard') {
				var elems = this.document.getElementsByClassName('myOrgNavLink')[0]
				this.myOrgClicked = true;
				if (elems != null) {
					elems.classList.remove("active");
					elems.className = "myOrgNavLink active";
				}
				this.activeClass = 'insights'
			}
			if (this.router.url === '/charities') {
				this.myOrgClicked = true;
				var elems = this.document.getElementsByClassName('myOrgNavLink')[0]
				this.myOrgClicked = true;
				if (elems != null) {
					elems.classList.remove("active");
					elems.className = "myOrgNavLink active";
				}
				this.activeClass = 'charities'
			}
		if (this.router.url === '/my-files') {
			this.myProfileClicked = true;
			var elems = this.document.getElementsByClassName('myOrgNavLink')[0]
			this.myProfileClicked = true;
			if (elems != null) {
				elems.classList.remove("active");
				elems.className = "myOrgNavLink active";
			}
			this.activeClass = 'my-files'
		}
		if (this.router.url === '/shared-doc') {
			this.myProfileClicked = true;
			var elems = this.document.getElementsByClassName('myOrgNavLink')[0]
			this.myProfileClicked = true;
			if (elems != null) {
				elems.classList.remove("active");
				elems.className = "myOrgNavLink active";
			}
			this.activeClass = 'shared-doc'
		}
		if (this.router.url === '/my-profile') {
			this.myProfileClicked = true;
			var elems = this.document.getElementsByClassName('myOrgNavLink')[0]
			this.myProfileClicked = true;
			if (elems != null) {
				elems.classList.remove("active");
				elems.className = "myOrgNavLink active";
			}
			this.activeClass = 'my-profile'
		}
		if (this.router.url === '/my-form-status') {
			this.myProfileClicked = true;
			var elems = this.document.getElementsByClassName('myOrgNavLink')[0]
			this.myProfileClicked = true;
			if (elems != null) {
				elems.classList.remove("active");
				elems.className = "myOrgNavLink active";
			}
			this.activeClass = 'my-form-status'
		}
			if (this.router.url === '/') {
				this.homeActive = true;
			}
			else if (this.router.url === '/') {
				this.homeActive = true;
			}
			else {
				this.homeActive = false;
			}
		}

	}



toggleUserMenu(event: MouseEvent) {
  event.preventDefault();
  event.stopPropagation();
  this.isUserMenuOpen = !this.isUserMenuOpen;
}

@HostListener('document:click')
closeUserMenuOnOutsideClick() {
  if (this.isUserMenuOpen) this.isUserMenuOpen = false;
}


	menuCall() {
		this.onSurveyModalClose();
		this.openMenuModal.nativeElement.click();

        if (isPlatformBrowser(this.platformId)) {
			if (this.router.url === '/nonProfit') {

				var elems = this.document.getElementsByClassName('nonProfit-nav-link')[0];
				if (elems != null) {
					elems.classList.remove("active");
					elems.className = "nonProfit-nav-link active";
				}

			}
			if (this.router.url === '/resources') {

				var elems = this.document.getElementsByClassName('resources-nav-link')[0];
				if (elems != null) {
					elems.classList.remove("active");
					elems.className = "resources-nav-link active";
				}

			}
			if (this.router.url === '/about-us') {

				var elems = this.document.getElementsByClassName('about-us-nav-link')[0];
				if (elems != null) {
					elems.classList.remove("active");
					elems.className = "about-us-nav-link active";
				}

			}
			// Release5 Article menu revert
			if (this.router.url === '/articles') {
				var elems = this.document.getElementsByClassName('article-nav-link')[0];
				if (elems != null) {
					elems.classList.remove("active");
					elems.className = "article-nav-link active";
				}
			}
		}
    }



	// go to relevant page
	goToPage(item?) {
		this.router.navigate(['/notification']);
	}

	// get notification count
	getNotiCount() {
		// Show loading state
		this.isLoading = true;
		
		this.subscription.add(this.dataService.get(URLS.getNotificationCount).subscribe(
			res => {
				if (res['code'] == 200) {
					this.notificationCount = res['data']['count'];
					this.commonService.localStorageSet('isAssociatedPartner', res['data']['isAssociatedPartner']);
					this.isAssociatedPartner = res['data']['isAssociatedPartner'];
					
					// Check for terms acceptance and handle modal logic
					if (res['data']['isAssociatedPartner']) {
						// Explicitly check if hasAcceptedNonprofitTnC is false from API response
						if (res['data']['hasAcceptedNonprofitTnC'] === false && res['data']['nonProfitTnc']) {
							this.commonService.localStorageSet('pendingTermsContent', res['data']['nonProfitTnc']);
							// Trigger modal on any page that supports it (charities, dashboard, newOrgDashboard)
							const currentUrl = this.router.url;
							if (currentUrl === '/charities' || currentUrl === '/dashboard' || currentUrl.startsWith('/newOrgDashboard') || currentUrl.startsWith('/neworgdashboard')) {
								// Check if modal is already open before opening it
								if (!this.showTermsModal && !this.modalService.isTermsModalOpen()) {
									setTimeout(() => {
										this.modalService.openTermsModal(res['data']['nonProfitTnc']);
									}, 500);
								}
							}
						}
					}
				}
				this.isLoading = false;
			},
			error => {
				console.error('Error fetching notification count:', error);
				this.isLoading = false;
			}
		));
	}

	// get notification list
	getNotificationList() {
		this.subscription.add(this.dataService.get(URLS.getNotificationList).subscribe(
			res => {
				if (res['code'] == 200) {
					this.notificatonMessages = res['data']['result'];
					//   console.log(this.notificatonMessages);
				}
			},
			error => {
				console.log(error);
			}
		))
	}

	navCall() {
		if (this.router.url === '/my-profile') {
            this.myProfileClicked=true;
			var elems = this.document.getElementsByClassName('profile-nav-link')[0];
			if (elems != null) {
				elems.classList.remove("active");
				elems.className = "myOrgNavLink active";
			}

		}
		if (this.router.url === '/my-address') {

			var elems = this.document.getElementsByClassName('address-nav-link')[0];
			if (elems != null) {
				elems.classList.remove("active");
				elems.className = "address-nav-link active";
			}

		}
		if (this.router.url === '/my-files') {

			this.myProfileClicked=true;
			var elems = this.document.getElementsByClassName(' file-nav-link')[0];
			if (elems != null) {
				elems.classList.remove("active");
				elems.className = "myOrgNavLink active";
			}

		}
		if (this.router.url === '/shared-doc') {
            this.myProfileClicked=true;
			var elems = this.document.getElementsByClassName('shared-nav-link')[0];
			this.myProfileClicked=true;
			if (elems != null) {
				elems.classList.remove("active");
				elems.className = "myOrgNavLink active";
			}

		}
		if (this.router.url === '/change-password') {
			var elems = this.document.getElementsByClassName('change-password-nav-link')[0];
			if (elems != null) {
				elems.classList.remove("active");
				elems.className = "change-password-nav-link active";
			}
		}
		if (this.router.url === '/dashboard') {
			var elems = this.document.getElementsByClassName('myOrgNavLink')[0]
			this.myOrgClicked = true;
			if (elems != null) {
				elems.classList.remove("active");
				elems.className = "myOrgNavLink active";
			}
		}
		if (this.router.url === '/charities') {
			this.myOrgClicked = true;
			var elems = this.document.getElementsByClassName('myOrgNavLink')[0]
			this.myOrgClicked = true;
			if (elems != null) {
				elems.classList.remove("active");
				elems.className = "myOrgNavLink active";
			}
		}
	}

	

    onHome() {
         this.homeActive = true;
         this.router.navigateByUrl('/');
     }

    // goToResources() {
    //     this.homeActive = false;
    //     this.router.navigateByUrl('/resources');
    // }

    // goToAboutUs() {
    //     this.homeActive = false;
    //     this.router.navigateByUrl('/about-us');
    // }

    // goToArticles() {
    //     this.homeActive = false;
    //     this.router.navigateByUrl('/articles');
    // }

	goToResources() {
		this.homeActive = false;
		this.router.navigateByUrl('/resources');
	}

	goToAboutUs() {
		this.homeActive = false;
		this.router.navigateByUrl('/about-us');
	}

	goToArticles() {
		this.homeActive = false;
		this.router.navigateByUrl('/articles');
	}

	goToNonProfit() {
		this.homeActive = false;
		this.router.navigateByUrl('/nonProfit');
	}


	onLogin() {
		this.homeActive = false;
		// this.router.navigateByUrl('/login');
		if(this.orgId)
		this.router.navigate(['/login'], { state: { orgId: this.orgId } });
	    else
        this.router.navigateByUrl('/login');
	}

	OnSignUp() {
		this.homeActive = false;
		this.router.navigate(['/create-account'], { state: { orgId: this.orgId } });
		this.verifiedMailStatus.emit('go to register page');
	}

	OnLogout() {
		if (!this.isLoggingOut) {
			this.isLoggingOut = true;
			this.subscription.add(
				this.dataService.get(URLS.logout).subscribe(data => {
					if (data['code'] == 200) {
						this.isLogin = false;
						this.commonService.localStorageClear();
						if (data['code'] == 200) {
							this.toastr.success('Success', data['message']);
						}
						this.cancelHeaderLogoutModal.nativeElement.click();
                        this.router.navigate(['/']);
						sessionStorage.clear();
					} else {
						this.toastr.error(data['message'], "Error");
					}
				}, error => {
					this.toastr.error(error['message'], "Error");
					this.commonService.localStorageClear();
                    this.router.navigate(['/']);
				})
			)
		}
	}


	closeMenuModal() {
		this.menuModalClose.nativeElement.click();
		// this.openSurveyModal.nativeElement.click();
		this.commonService.triggerSurveyModal();
	}

	closeMainMenuModal() {
		this.menuModalClose.nativeElement.click();
	}

	onSurveyModalClose() {
        if (isPlatformBrowser(this.platformId)) {
			this.menuModalClose.nativeElement.click();
			const modal = this.document.getElementById('surveyModal');
			const backdrop = this.document.querySelector('.modal-backdrop');
			if (modal && backdrop && !modal.classList.contains('show')) {
				backdrop.remove();  // Properly remove the backdrop
			}
		}
	}


	logoutClicked() {
		this.menuModalClose.nativeElement.click();
		this.commonService.triggerLogoutModal();
	}


		ngAfterViewInit() {
		if (isPlatformBrowser(this.platformId)) {
			const modalElement = document.getElementById('surveyModal');
			if (modalElement) {
				modalElement.addEventListener('shown.bs.modal', () => {
					this.onModalShown();
				});
				modalElement.addEventListener('hidden.bs.modal', () => {
					this.onModalHidden();
				});
			}
			
			// Check for pending terms content after view is initialized
			const pendingTermsContent = this.commonService.localStorageGet('pendingTermsContent');
			
			// Only trigger if there's pending content and modal isn't already shown
			// AND only on allowed routes (charities, dashboard, newOrgDashboard)
			if (pendingTermsContent && !this.showTermsModal && !this.modalService.isTermsModalOpen()) {
				const currentUrl = this.router.url;
				if (currentUrl === '/charities' || currentUrl === '/dashboard' || currentUrl.startsWith('/newOrgDashboard') || currentUrl.startsWith('/neworgdashboard')) {
					// Use setTimeout to avoid ExpressionChangedAfterItHasBeenCheckedError
					setTimeout(() => {
						this.modalService.openTermsModal(pendingTermsContent);
					}, 0);
				}
			}
		}
	}

	onModalShown() {
		this.isModalActive = true;
	}

	onModalHidden() {
		this.isModalActive = false;
	}

	myOrg(event) {
		// this.myOrgClicked = !this.myOrgClicked;
		event.stopPropagation();
	}

	profile(event){
		// this.myProfileClicked = !this.myProfileClicked;
		event.stopPropagation();
	}

	stopPropagation(event){
		event.stopPropagation();
	}

	toggleDropdown(event: Event) {
		event.preventDefault();
		const target = event.target as HTMLElement;
		const dropdownElement = target.closest('[data-bs-toggle="dropdown"]');
		
		if (dropdownElement) {
			try {
				// Try to get existing Bootstrap dropdown instance
				let dropdown = bootstrap.Dropdown.getInstance(dropdownElement);
				
				if (!dropdown) {
					// Create new instance if it doesn't exist
					dropdown = new bootstrap.Dropdown(dropdownElement);
				}
				
				// Toggle the dropdown
				dropdown.toggle();
			} catch (error) {
				console.error('Error toggling dropdown:', error);
				// Fallback: manually toggle classes
				const dropdownMenu = dropdownElement.nextElementSibling;
				if (dropdownMenu && dropdownMenu.classList.contains('dropdown-menu')) {
					dropdownMenu.classList.toggle('show');
					dropdownElement.setAttribute('aria-expanded', 
						dropdownMenu.classList.contains('show') ? 'true' : 'false');
				}
			}
		}
	}


	getOrgId() {
		let params = {
			url: this.pageUrl
		}
		this.subscription.add(
			this.dataService.post(URLS.getOrgId, params).subscribe(data => {
				if (data['code'] == 200) {
					if (data['data']) {
						this.orgId = data['data']['orgId'];
					}
				} else {
					this.toastr.error(data['message'], "Error");
				}
			}, error => {
				this.toastr.error(error['message'], "Error");
			})
		)
	}

	// Terms Modal Methods
	nextSection() {
		if (isPlatformBrowser(this.platformId)) {
			const modalBody = document.querySelector('#termsModal .modal-body');
			if (modalBody) {
				const isAtBottom = modalBody.scrollTop + modalBody.clientHeight >= modalBody.scrollHeight - 10;
				
				if (isAtBottom && this.agreed) {
					// Handle API call first, then close modal on success
					this.subscription.add(
						this.dataService.put(URLS.acceptTerms).subscribe(data => {
							if (data['code'] == 200) {
								// Update local storage to reflect terms acceptance
								this.commonService.localStorageSet('hasAcceptedNonprofitTnC', true);
								const pendingTermsContent = this.commonService.localStorageGet('pendingTermsContent');
								if (pendingTermsContent) {
									// Clear the pending content
									this.commonService.localStorageRemove('pendingTermsContent');
								}
								this.toastr.success('Terms accepted successfully!', 'Success');
								
								// Now close the modal
								this.closeTermsModal();
							} else {
								this.toastr.error(data['message'], "Error");
							}
						}, error => {
							this.toastr.error(error['message'], "Error");
						})
					);
				} else {
					// Simple scroll down
					modalBody.scrollTop = modalBody.scrollTop + modalBody.clientHeight;
				}
			}
		}
	}

	getButtonText(): string {
		if (isPlatformBrowser(this.platformId)) {
			const modalBody = document.querySelector('#termsModal .modal-body');
			if (modalBody) {
				const isAtBottom = modalBody.scrollTop + modalBody.clientHeight >= modalBody.scrollHeight - 10;
				this.isAtBottom = isAtBottom;
				
				if (this.currentSection === this.totalSections) {
					return isAtBottom ? 'Accept' : 'Continue Reading';
				}
			}
		}
		
		return 'Continue Reading';
	}

	onModalBodyScroll() {
		// This method is called when the modal body is scrolled
		// The scroll detection is handled in getButtonText()
	}

	closeTermsModal() {
		// Only close if user has agreed to terms
		if (!this.agreed) {
			return;
		}

		// Use comprehensive cleanup
		this.cleanupBootstrapModal();
		
		this.modalService.closeTermsModal();
		this.showTermsModal = false;
		this.agreed = false;
		this.currentSection = 1;
		this.isAtBottom = false;
		
		// Additional cleanup after state update
		setTimeout(() => {
			this.cleanupBootstrapModal();
		}, 50);
	}

	private cleanupBootstrapModal() {
		if (isPlatformBrowser(this.platformId)) {
			try {
				// Clean up the terms modal specifically
				const modalElement = document.querySelector('#termsModal');
				if (modalElement) {
					// Hide and dispose the Bootstrap modal instance
					const modalInstance = bootstrap.Modal.getInstance(modalElement);
					if (modalInstance) {
						modalInstance.hide();
						modalInstance.dispose();
					}
					
					// Remove show class and hide the modal
					modalElement.classList.remove('show');
					(modalElement as HTMLElement).style.display = 'none';
				}
				
				// Clean up all modal backdrops
				const backdrops = document.querySelectorAll('.modal-backdrop');
				backdrops.forEach(backdrop => backdrop.remove());
				
				// Remove modal-open class from body if no other modals are open
				const openModals = document.querySelectorAll('.modal.show');
				if (openModals.length === 0) {
					document.body.classList.remove('modal-open');
					document.body.style.overflow = '';
					document.body.style.paddingRight = '';
				}
				
				// Clean up any remaining overlay elements
				const overlays = document.querySelectorAll('.modal-backdrop, .modal-overlay');
				overlays.forEach(overlay => overlay.remove());
				
				// Reset body styles if no other modals are open
				if (document.querySelectorAll('.modal.show').length === 0) {
					document.body.style.overflow = 'auto';
					document.body.style.position = '';
				}
				
				// Force a reflow to ensure styles are applied
				document.body.offsetHeight;
				
			} catch (error) {
				console.warn('Error during modal cleanup:', error);
			}
		}
	}

}
